module.exports = __webpack_public_path__ + "img/icons8-marker.7fc7302b.svg";